import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ProfilePreviewWrapper } from "../Dashboard/ProfilePage/style";
import { getStorage } from "../../Utils/common";
import './BureauScoreDisplay.css';

function BureauScoreDisplay() {
  const navigate = useNavigate();
  const location = useLocation();

  // Get score data from location state, fall back to storage, then to the
  // fixed demo value so this page always has something to show.
  const storedScore = (() => {
    try {
      return JSON.parse(localStorage.getItem('bureau_score'));
    } catch {
      return null;
    }
  })();

  const scoreData = location.state?.bureauScore || storedScore || {
    score: 700,
    isDemo: true,
    lastUpdated: new Date().toLocaleDateString('en-IN', {
      day: 'numeric', month: 'long', year: 'numeric'
    })
  };

  const mobileNumber = getStorage("mobile") || getStorage("user_mobile") || "";

  const getScoreRating = (score) => {
    if (score >= 750) return { label: 'EXCEPTIONAL', color: '#0d6b4f' };
    if (score >= 700) return { label: 'GREAT', color: '#128a5f' };
    if (score >= 650) return { label: 'GOOD', color: '#3aa676' };
    if (score >= 550) return { label: 'FAIR', color: '#e0a72e' };
    return { label: 'POOR', color: '#d9534f' };
  };

  const rating = getScoreRating(scoreData.score);

  // Gauge math: map score 300-900 onto a 180 degree arc
  const minScore = 300;
  const maxScore = 900;
  const clampedScore = Math.min(Math.max(scoreData.score, minScore), maxScore);
  const needleRotation = ((clampedScore - minScore) / (maxScore - minScore)) * 180;

  const handleBack = () => {
    navigate('/my-dashboard');
  };

  return (
    <ProfilePreviewWrapper>
      <div className="bureau-score-container">
        

        {/* Main Score Card */}
        <div className="score-card">
          {/* Gauge */}
          <div className="score-gauge">
            <svg viewBox="0 0 200 110" className="gauge-svg">
              <path
                d="M 10 100 A 90 90 0 0 1 55 21"
                fill="none" stroke="#8fd3b5" strokeWidth="16" strokeLinecap="round"
              />
              <path
                d="M 55 21 A 90 90 0 0 1 100 10"
                fill="none" stroke="#5fc19a" strokeWidth="16" strokeLinecap="round"
              />
              <path
                d="M 100 10 A 90 90 0 0 1 145 21"
                fill="none" stroke="#2fa87e" strokeWidth="16" strokeLinecap="round"
              />
              <path
                d="M 145 21 A 90 90 0 0 1 190 100"
                fill="none" stroke="#0d6b4f" strokeWidth="16" strokeLinecap="round"
              />
              <circle
                cx={100 - 80 * Math.cos((needleRotation * Math.PI) / 180)}
                cy={100 - 80 * Math.sin((needleRotation * Math.PI) / 180)}
                r="6" fill="#ffffff" stroke={rating.color} strokeWidth="3"
              />
            </svg>
            <div className="gauge-labels">
              <span>Poor</span>
              <span>Fair</span>
              <span>Good</span>
              <span>Great</span>
              <span>Exceptional</span>
            </div>
          </div>

          {/* Score Display */}
          <div className="score-display">
            <span className="score-number" style={{ color: rating.color }}>
              {scoreData.score}
            </span>
            <span className="score-label">Your Demo Score</span>
          </div>

          {/* <p className="score-updated">Last updated: {scoreData.lastUpdated}</p> */}

          {mobileNumber && (
            <p className="mobile-info">Linked to: {mobileNumber}</p>
          )}
        </div>

        {/* Back Button */}
        <div className="back-button-container">
          <button className="back-dashboard-btn" onClick={handleBack}>
            ← Back to Dashboard
          </button>
        </div>
      </div>
    </ProfilePreviewWrapper>
  );
}

export default BureauScoreDisplay;